import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import PropTypesImmutable from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import {
  getClassifiersExternalRegistryList,
  getClassifiersExternalRegistryListData,
  getClassifiersExternalRegistryDelete,
} from '../../reducers/classifiersReducer';
import {
  showExternalRegistryEditModal,
  hideExternalRegistryEditModal,
  getExternalRegistryEditModal,
} from '../../actions/actionCreators/modalsActionCreators';
import { getLoadingSelector } from '../../utils/asyncHelpers';
import { Spin, Modal, Button } from 'antd';
import * as actions from '../../actions/actionCreators/classifiersActionCreators';
import { ExternalRegistryTable, TableActions } from '../../components';
import { ExternalRegistryEdit as ExternalRegistryEditForm } from '../../forms';
import { goToClassifiers } from '../../utils/gotoLink';

const ExternalRegistryList = ({
  t,
  loading,
  fetchClassifier,
  deleteClassifier,
  classifierData,
  modalVisible,
  hideModal,
  showModal,
}) => {
  const selectedCodeRef = useRef(null);

  useEffect(() => {
    fetchClassifier();
  }, [fetchClassifier]);

  const handleShowModal = (code = null) => {
    selectedCodeRef.current = code;
    showModal();
  };

  return (
    <Spin spinning={loading}>
      <h1>{t('externalRegistry')}</h1>
      {classifierData && (
        <ExternalRegistryTable
          t={t}
          dataSource={classifierData.toJS()}
          deleteClassifier={deleteClassifier}
          showModal={handleShowModal}
        />
      )}
      {modalVisible && (
        <Modal
          title={t('externalRegistry')}
          open
          footer={null}
          onCancel={hideModal}
          width={640}
        >
          <ExternalRegistryEditForm
            onCancel={hideModal}
            onComplete={hideModal}
            operatorCode={selectedCodeRef.current}
            t={t}
          />
        </Modal>
      )}
      <TableActions>
        <Button onClick={goToClassifiers}>{t('buttonBack')}</Button>
        <Button
          type="primary"
          onClick={() => handleShowModal(null)}
          className="global-margin-left-10"
        >
          {t('buttonValueAdd')}
        </Button>
      </TableActions>
    </Spin>
  );
};

ExternalRegistryList.propTypes = {
  t: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  fetchClassifier: PropTypes.func.isRequired,
  deleteClassifier: PropTypes.func.isRequired,
  classifierData: PropTypesImmutable.list,
  modalVisible: PropTypes.bool.isRequired,
  hideModal: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
};

const getIsLoading = getLoadingSelector(
  getClassifiersExternalRegistryList,
  getClassifiersExternalRegistryDelete
);

const mapStateToProps = (state) => ({
  loading: getIsLoading(state),
  classifierData: getClassifiersExternalRegistryListData(state),
  modalVisible: getExternalRegistryEditModal(state),
});

const mapDispatchToProps = (dispatch) => ({
  fetchClassifier: () => {
    dispatch(actions.fetchClassifierExternalRegistryList());
  },
  deleteClassifier: async (code) => {
    await dispatch(actions.deleteClassifierExternalRegistry(code));
    dispatch(actions.fetchClassifierExternalRegistryList());
  },
  showModal: () => {
    dispatch(showExternalRegistryEditModal());
  },
  hideModal: () => {
    dispatch(hideExternalRegistryEditModal());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExternalRegistryList);
